import {
  AbstractControl,
  FormArray,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';

/**
 * FormArray-level validator that checks all `resource` controls within child FormGroups for
 * duplicate values (case-insensitive, trimmed). Duplicate controls receive a `duplicateResource`
 * error; controls that are no longer duplicates have it cleared.
 */
export function uniqueResourceValidator(duplicateResourceKey: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!(control instanceof FormArray)) {
      return null;
    }

    const groups = control.controls.filter((c): c is FormGroup => c instanceof FormGroup);
    const resourceControls = groups.map((g) => g.controls['resource']).filter(Boolean);

    const values = resourceControls.map((c) => c.value?.trim().toLowerCase() ?? '');
    let hasDuplicate = false;

    resourceControls.forEach((resourceControl, index) => {
      const value = values[index];
      const isDuplicate = value !== '' && values.some((v, i) => i !== index && v === value);

      if (isDuplicate) {
        hasDuplicate = true;
        resourceControl.setErrors({
          ...(resourceControl.errors ?? {}),
          duplicateResource: duplicateResourceKey,
        });
      } else {
        if (resourceControl.hasError('duplicateResource')) {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          const { duplicateResource: _, ...remainingErrors } = resourceControl.errors ?? {};
          resourceControl.setErrors(Object.keys(remainingErrors).length ? remainingErrors : null);
        }
      }
    });

    return hasDuplicate ? { duplicateResource: true } : null;
  };
}
